import * as React from 'react';
import './additional-completion-modal.scss';
import Button from '../../../common/button/button';

interface Props {
    onClose: Function;
}

const AdditionalCompletionModal: React.FC<Props> = ({ onClose }) => {
    const onCloseModal = () => {
        onClose(false);
    };

    return (
        <div className="additional-completion-modal-background">
            <div className="additional-completion-modal">
                <div className="additional-completion-modal__head">결제 정보</div>
                <div className="additional-completion-modal__subhead">체크리스트가 추가되었습니다.</div>
                <div className='additional-completion-modal__button'>
                    <Button label={'확인'} type={'type2'} action={onCloseModal} />
                </div>
            </div>
        </div>
    );
};
export default AdditionalCompletionModal;
